export interface FolderContext {
  kind: 'company' | 'project' | 'task';
  id: string;
}

export interface FileAttachmentCapabilities {
  canRename: boolean;
  canMove: boolean;
  canDelete: boolean;
}

/** Folder metadata and attachment IDs only; FileDataService owns the file models. */
export class ExplorerFolder {
  public id: string;
  public name: string;
  public parentFolderId?: string;
  public subFolderIds: string[] = [];
  public fileIds: string[] = [];
  public fileCapabilities: Record<string, FileAttachmentCapabilities> = {};
  public createdAt?: Date;
  public createdById?: string;
  public type?: number;
  public systemKey?: number;
  public isSystem = true;
  public externalFolderUrl?: string;
  public canManageExternalFolder = false;
  public canCreateFolder = false;
  public canUploadFiles = false;
  public canRename = false;
  public canDelete = false;

  public constructor(value: Partial<ExplorerFolder>) {
    Object.assign(this, value);
  }
}
